import React, { useState, useEffect, useRef } from "react";
import DateRangePicker from "rsuite/DateRangePicker";
import moment from "moment";
import {
  getLastMonth,
  getLastWeek,
  getLastTenDays,
} from "../../../utility/common-methods";
import { DATE_FORMATS } from "../../../constants/app-constant";
import { isMobile } from "../../../utility/deviceUtils";
import {DateRangePicker as BDateRangePicker} from 'react-bootstrap-daterangepicker'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

const [today, lastWeek, lastTenDays, custom] = [0, 1, 2, 3];

var date = new Date();
var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

export default function DateRangeFilter({
  handleDateChange,
  startRange,
  endRange,
  showShortCut = false,
  minDate = "",
  maxDate = "",
  isSocialMain,
  datePickerPlacement = "bottomEnd",
  filterTab = false,
  isPrintAndOnline = false,
  isDownloadreport,
  setSelectedMonth,
  qualitative = false,
  isSocial = false,
}) {
  const datePickerRef = useRef();
  const [isDateOptionSelected, setIsDateOptionSelected] = useState(true);
  const [beginDate, setBeginDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isStartDate, setIsStartDate] = useState(true);
  const [firstDate, setFirstDate] = useState(null);
  const [dateRangeValue, setdateRangeValue] = useState(null);
  const handlDateShortcutClick = (currentSelectedFilter) => {
    try {
      let tempDateObj = { startDate: startRange, endDate: endRange };
      const todayDate = moment();
      if (currentSelectedFilter === lastTenDays) {
        tempDateObj = {
          startDate: moment().subtract(10, "days").startOf("day"),
          endDate: moment().subtract(1, "day").endOf("day"),
        }
      } else if (currentSelectedFilter === lastWeek) {
        tempDateObj = {
          startDate: moment().subtract(1, "weeks").startOf("day"),
          endDate: moment().subtract(1, "day").endOf("day"),
        }
      } else if (currentSelectedFilter === today) {
        tempDateObj = {
          startDate: moment(todayDate).startOf("day"),
          endDate: moment(todayDate).endOf("day"),
        };
      } else {
        tempDateObj = {
          startDate: firstDay,
          endDate: lastDay,
        };
      }
      if(isSocial){
        handleDateChange({from : tempDateObj.startDate,to: tempDateObj.endDate}, "start");
      }
      else{
        handleDateChange(tempDateObj.startDate, "start");
        handleDateChange(tempDateObj.endDate, "end");
      }
      setBeginDate(null);
      setEndDate(null);
      setIsDateOptionSelected(true);
    } catch (e) {}
  };

  const isSelectedFilter = (type) => {
    try {
      if (type === today) {
        const todayDate = moment().format("yyyy/MM/DD");
        return (
          moment(startRange).isSame(moment(todayDate), "day") &&
          moment(endRange).isSame(moment(todayDate), "day")
        );
      } else if (type === lastTenDays) {
        const tempDateObj = getLastTenDays(new Date());
        return (
          moment(startRange).isSame(moment(tempDateObj.startDate)) &&
          moment(endRange).isSame(moment(tempDateObj.endDate))
        );
      } else {
        const tempDateObj = getLastWeek(new Date());
        return (
          moment(startRange).isSame(moment(tempDateObj.startDate)) &&
          moment(endRange).isSame(moment(tempDateObj.endDate))
        );
      }
    } catch (e) {}
  };
  const handleClean = () => {
    setBeginDate(null);
    setEndDate(null);
    setIsDateOptionSelected(true);
    handlDateShortcutClick(today);
  };

  const handleDateSelect = (d) => {
    if (isDownloadreport) {
      setIsDateOptionSelected(false);
      setSelectedMonth(moment(d).format("yyyy-MM"));
      datePickerRef.current.close();
    } else {
      setIsDateOptionSelected(false);
      if (isStartDate) {
        if(isSocial){
          setFirstDate(moment(d));  
        }
        else{
          setFirstDate(moment(d).format("yyyy/MM/DD"));
        }
        setIsStartDate(false);
      } else {
        if (moment(firstDate).isBefore(moment(d))) {
          handleDateChange(firstDate, "start");
          if(isSocial){
            handleDateChange(moment(d), "end");
            setEndDate(moment(d));
            setdateRangeValue([new Date(moment(firstDate).format(DATE_FORMATS.DTS_MMYYYYDD_dash)),new Date(moment(d).format(DATE_FORMATS.DTS_MMYYYYDD_dash))])
          }
          else{
            handleDateChange(moment(d).format("yyyy/MM/DD"), "end");
            setEndDate(moment(d).format("yyyy/MM/DD"));
            setdateRangeValue([new Date(firstDate),new Date(moment(d).format("yyyy/MM/DD"))])
          }
          setBeginDate(firstDate);
          setEndDate(moment(d).format("yyyy/MM/DD"));
        } else {
          handleDateChange(firstDate, "end");
          if(isSocial){
            handleDateChange(moment(d), "start");
            setBeginDate(moment(d).format(DATE_FORMATS.DTA_DDMMYYYY_dash_momet));
            setdateRangeValue([new Date(moment(d).format(DATE_FORMATS.DTS_MMYYYYDD_dash)),new Date(moment(firstDate).format(DATE_FORMATS.DTS_MMYYYYDD_dash))])
          }
          else{
            handleDateChange(moment(d).format("yyyy/MM/DD"), "start");
            setBeginDate(moment(d).format("yyyy/MM/DD"));
            setdateRangeValue([new Date(moment(d).format("yyyy/MM/DD")),new Date(firstDate)])
          }
          setEndDate(firstDate);
        }
        // datePickerRef.current.close();
      }
    }
  };

  const handleDateChangeEvent = (data,picker) => {
    handleDateChange({from : picker.startDate,to : picker.endDate}, "both");
    picker.element.val(
      picker.startDate.format('DD-MM-YYYY hh:mm a') +
      ' - ' +
      picker.endDate.format('DD-MM-YYYY hh:mm a')
    );
  }

  let optionalPropsv1 = {
    disabledDate: (current) => {
      const date = moment(new Date()).format("YYYY-MM-DD");
      return (
        moment(date).add(-730, "days") >= current ||
        moment(date).add(730, "days") <= current
      );
    },
  };

  let optionalProps = {
    disabledDate: (current) => {
      const date = moment(new Date()).format("YYYY-MM-DD");
      return (
        moment(date).add(-31, "days") >= current ||
        moment(date).add(31, "days") <= current
      );
    },
  };

  const oneMonthRangeDisable = () => {
    const date = moment(new Date()).format("YYYY-MM-DD");
    const diff = moment(date).diff(firstDate, "days");
    const diffDate = diff - 31;
    const baseStart = moment(date).add(-31, "days");
    const baseEnd = moment(date).add(31, "days");
    optionalProps.disabledDate = (current) => {
      if (diff >= 31) {
        const rangeStart = moment(firstDate).add(-31, "days");
        const rangeEnd = moment(firstDate).add(31, "days");
        return (
          (baseStart > rangeStart ? baseStart : rangeStart) >= current ||
          (baseEnd < rangeEnd ? baseEnd : rangeEnd) <= current
        );
      }
      if (diff <= 31) {
        if (diff < 0) {
          const rangeStart = moment(firstDate).add(diffDate - diff, "days");
          const rangeEnd = moment(firstDate).add(31 + diff, "days");
          return (
            (baseStart > rangeStart ? baseStart : rangeStart) >= current ||
            rangeEnd <= current
          );
        }
        if (diff >= 0) {
          const rangeStart = moment(firstDate).add(diffDate - diff, "days");
          const rangeEnd = moment(firstDate).add(31, "days");
          return (
            (baseStart > rangeStart ? baseStart : rangeStart) >= current ||
            (baseEnd < rangeEnd ? baseEnd : rangeEnd) <= current
          );
        }
      }
    };
  };

  const oneMonthRangeDisable2 = () => {
    const date = moment(new Date()).format("YYYY-MM-DD");
    const diff = moment(date).diff(firstDate, "days");
    const diffDate = diff - 31;
    optionalProps.disabledDate = (current) => {
      let bool;
      if (diff >= 31) {
        bool =
          moment(firstDate).add(-31, "days") >= current ||
          moment(firstDate).add(31, "days") <= current;
      }
      if (diff <= 31) {
        if (diff < 0) {
          bool =
            moment(firstDate).add(diffDate - diff - 31, "days") >= current ||
            moment(firstDate).add(31 + diff, "days") <= current;
        }
        if (diff >= 0) {
          bool =
            moment(firstDate).add(diffDate - diff, "days") >= current ||
            moment(firstDate).add(31, "days") <= current;
        }
      }
      return bool || moment(minDate) > current;
    };
  };

  const threeMonthRangeDisable = () => {
    const date = moment(new Date()).format("YYYY-MM-DD");
    const diff = moment(date).diff(firstDate, "days");
    const diffDate = diff - 91;
    optionalProps.disabledDate = (current) => {
      let bool;
      if (diff >= 91) {
        bool =
          moment(firstDate).add(-91, "days") >= current ||
          moment(firstDate).add(91, "days") <= current;
      }
      if (diff <= 91) {
        if (diff < 0) {
          bool =
            moment(firstDate).add(diffDate - diff - 91, "days") >= current ||
            moment(firstDate).add(91 + diff, "days") <= current;
        }
        if (diff >= 0) {
          bool =
            moment(firstDate).add(diffDate - diff, "days") >= current ||
            moment(firstDate).add(91, "days") <= current;
        }
      }
      return bool || moment(minDate) > current;
    };
  };

  const disabledFutureDates = () => {
    if (minDate || maxDate) {
      /*
      optionalProps.disabledDate = (current) => {
        const date = moment(new Date()).format("YYYY-MM-DD");
        return (
          moment(date).add(-31, "days") >= current ||
          moment(date).add(31, "days") <= current
        );
      };
      */
      // /*
      const date = moment(new Date()).format("YYYY-MM-DD");
      const start = moment(minDate);
      const end = moment(date);
      optionalProps.disabledDate = function (dt) {
        const date = moment(dt);
        if (minDate && maxDate) {
          return qualitative
            ? !date.isBetween(
                moment(start).subtract(1, "days").format("YYYY-MM-DD"),
                moment(end).add(91, "days").format("YYYY-MM-DD")
              )
            : !date.isBetween(
                moment(start).subtract(1, "days").format("YYYY-MM-DD"),
                moment(end).add(31, "days").format("YYYY-MM-DD")
              );
        }
        return (
          (minDate && start.diff(date, "days") > 0) ||
          (maxDate && end.diff(date, "days") < 0)
        );
      };
      // */
    }
  };
  firstDate && !isDateOptionSelected
    ? qualitative
      ? threeMonthRangeDisable()
      : oneMonthRangeDisable2()
    : disabledFutureDates();
  return (
    <>
      {showShortCut && (
        <div role="group" className="rs-btn-group btn-group">
          <button
            onClick={() => handlDateShortcutClick(today)}
            value="today"
            type="button"
            className={`btn btn-primary ${
              isSelectedFilter(today) ? "active" : ""
            }`}
          >
            Today
          </button>
          <button
            onClick={() => handlDateShortcutClick(lastWeek)}
            value="today"
            type="button"
            className={`btn btn-primary ${
              isSelectedFilter(lastWeek) ? "active" : ""
            }`}
          >
            Last Week
          </button>
          <button
            onClick={() => handlDateShortcutClick(lastTenDays)}
            value="today"
            type="button"
            className={`btn btn-primary ${
              isSelectedFilter(lastTenDays) ? "active" : ""
            }`}
          >
            Last 10 Days
          </button>
        </div>
      )}
      {isSocial && <BDateRangePicker
          placeholder="Select Date Range social"
          onApply={handleDateChangeEvent}
          initialSettings={{
            timePicker: true,
            startDate: moment().startOf('day').toDate(),
            endDate: moment().endOf('day').toDate(),
            locale: {
              format: 'DD/MM/YYYY hh:mm A',
            },
          }}
        >
          <input type="text" className="form-control col-4" />
        </BDateRangePicker>}
      {!isSocial && !isPrintAndOnline && !isDownloadreport && (
        <DateRangePicker
          ref={datePickerRef}
          key={JSON.stringify(startRange + endRange)}
          placeholder="Select Date Range"
          onEnter={() => {setIsStartDate(true);setdateRangeValue(null)}}
          onSelect={(d) => handleDateSelect(d)}
          onClean={() => handleClean()}
          ranges={[]}
          format={isSocial?DATE_FORMATS.DTA_DDMMYYYY_dash:DATE_FORMATS.ddMMYYYY_dash}
          {...(!isSocial && beginDate && endDate ? { value: dateRangeValue } : {})}
          // defaultValue={[startRange, endRange]}
          defaultCalendarValue={[firstDay, lastDay]}
          placement={datePickerPlacement}
          // renderValue={(value, formatString) =>
          //   moment(value[0]).isSame(moment(value[1]), "day")
          //     ? moment(value[0]).format("DD-MM-yyyy")
          //     : `${moment(value[0]).format("DD-MM-yyyy")} ~ ${moment(
          //         value[1]
          //       ).format("DD-MM-yyyy")}`
          // }
          {...optionalPropsv1}
          showOneCalendar={isMobile()}
        />
      )}
      {!isSocial && isDownloadreport && (
        <DateRangePicker
          oneTap
          showOneCalendar
          ref={datePickerRef}
          key={JSON.stringify(startRange + endRange)}
          placeholder="Select Date Range"
          // onEnter={() => setIsStartDate(true)}
          onSelect={(d) => handleDateSelect(d)}
          hoverRange="month"
          // onClean={() => handleClean()}
          ranges={[]}
          format="yyyy-MM"
          // {...(beginDate && endDate ? { value: [beginDate, endDate] } : {})}
          // defaultValue={[startRange, endRange]}
          // defaultCalendarValue={[firstDay, lastDay]}
          placement={datePickerPlacement}
          renderValue={(value, formatString) =>
            moment(value[0]).isSame(moment(value[1]), "month")
              ? moment(value[0]).format("yyyy-MM")
              : `${moment(value[0]).format("yyyy-MM")} ~ ${moment(
                  value[1]
                ).format("yyyy-MM")}`
          }
          // {...optionalProps}
        />
      )}
    </>
  );
}
